<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<div *ngIf="collapsed && app.displayName.length>0" (click)="toggleCollapsed()" class="safe-app-wrapper">
    <div class="flex-container">
        <div class="safe-app-header">
            <span class="mdi md-24 mdi-chevron-right" tabindex="0" (keyup.enter)="toggleCollapsed()" role="button" aria-label="Expand Application Configuration"></span>
            {{app.displayName}}
        </div>
        <div style="right:0">
            <mat-slide-toggle name="enabled" class="enabled-slide-toggle" [(ngModel)]="app.enabled" (change)="changed.emit()" (click)="$event.stopPropagation()" color="primary" aria-label="Application Enabled Status"></mat-slide-toggle>
        </div>
    </div>
</div>

<div *ngIf="!collapsed || app.displayName.length===0" class="expanded">
    <div class="flex-container">
        <div class="safe-app-header">
            <span class="mdi mdi-chevron-down" (click)="collapse()" tabindex="0" (keyup.enter)="toggleCollapsed()" role="button" aria-label="Collapse Application Configuration"></span>
            <input name="name" class="display-name" type="text" [(ngModel)]="app.displayName" (click)="$event.stopPropagation()" (keydown)="keyAlphaNum($event)" (blur)="isDupeName()" #displayNameInput required [readonly]="app.app > 0" aria-label="Application Name">
            <button mat-icon-button (click)="deleteApp.emit(app)" (keyup.enter)="deleteApp.emit(app)" matTooltip="{{'DELETE_APPLICATION' | translate}}" matTooltipShowDelay="350" matTooltipPosition="right" *ngIf="app.app === 0" aria-label="Delete Application">
                <span class="mdi mdi-close-circle"></span>
            </button>
        </div>
        <div>
            <mat-slide-toggle name="enabled" class="enabled-slide-toggle" [(ngModel)]="app.enabled" (change)="changed.emit()" (click)="$event.stopPropagation()" color="primary" aria-label="Application Enabled Status"></mat-slide-toggle>
        </div>
    </div>
    <div class="flex-container">
        <div class="extracted-certificate-heading">{{'EXTRACTED_CERT_TITLE' | translate}}</div>
        <div>
            <button type="button" (click)="upload()" color="primary" mat-button [disabled]="app.displayName.length===0 || app.app > 0">{{getUploadButtonText()}}</button>
        </div>
    </div>
    <div class="certificate-details">
        <div>
            <mat-form-field appearance="outline">
                <input readonly matInput type="text" [(ngModel)]="app.subject.CN" placeholder="Common Name (CN)" (keydown)="changed.emit()" />
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <input readonly matInput type="text" [(ngModel)]="app.subject.O" placeholder="Organization (O)" (keydown)="changed.emit()" />
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <input readonly matInput type="text" [(ngModel)]="app.subject.L" placeholder="Locality (L)" (keydown)="changed.emit()" />
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <input readonly matInput type="text" [(ngModel)]="app.subject.ST" placeholder="State or Province (ST)" (keydown)="changed.emit()" />
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <input readonly matInput type="text" [(ngModel)]="app.subject.C" placeholder="Country Code (C)" (keydown)="changed.emit()" />
            </mat-form-field>
        </div>
    </div>

    <app-path-list [(paths)]="app.paths" [d3ePolicy]="d3ePolicy" [dupeCertificate]="dupeCertificate" (changed)="changed.emit()" [disabled]="!app.subject.CN || app.subject.CN.length===0 || app.app > 0" (enable)="app.enabled=true"></app-path-list>
</div>
